<template>
  <div id="footer" style="width: 100%">
    <div class="width">
      <p style="text-align:center;"><span style="font-size:12px;">Copyright &copy; &nbsp;</span><span
          style="font-size:12px;">中国高新技术新闻网——掌握国内外科技资讯大全，专注于高新技术产业新闻资讯</span></p>
      <p style="text-align:center;"><span style="font-size:12px;">技术支持：盒子科技</span></p>
      <p style="text-align:center;"><span style="font-size:12px;">
        版权声明：本网站所刊内容未经本网站及作者本人许可， 不得下载、转载或建立镜像等，违者本网站将追究其法律责任。本网站所用文字图片部
        分来源于公共网络或者素材网站，凡图文未署名者均为原始状况，但作者发现后可告知认领，我们仍会及时署名或依照作者本人意愿处理，
        如未及时联系本站，本网站不承担任何责任。<br/></span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Footer"
}
</script>

<style scoped>

</style>